<template>
  <!-- 加班申请 -->
  <div class="detail">
    <ax-panel title="加班信息">
      <van-cell title="申请人">
        <a class="link_a" :href="'tel:' + data.header.emplid_phone">
          {{
          data.header.emplid_description
          }}
        </a>
      </van-cell>
      <van-cell title="申请原因" :value="data.header.qh_ot_reason_description"></van-cell>

      <van-cell title="加班地点" :value="data.header.qh_ot_location_description"></van-cell>
      <van-cell title="加班天数">
        <router-link
          class="link_a"
          :to="{
            name: 'approvalDetailList',
            query: $route.query
          }"
        >{{ data.header.qh_total_days }}天</router-link>
      </van-cell>
      <van-cell title="加班说明" :value="data.header.comments"></van-cell>
      <van-cell title="附件" v-if="data.qh_abs_008_atta.length">
        <ax-down
          v-for="(fileItem, index) in data.qh_abs_008_atta"
          type="ssc"
          :data="{
            fileName: fileItem.filename
          }"
          :key="index"
        >
          <router-link
            slot="fileName"
            class="link_a"
            :to="{
              name: 'fileImg',
              query: {
                ...$route.query,
                attachsysfilename: fileItem.attachsysfilename, // 附件唯一名称
                emplid: data.header.emplid, // 员工编号
                action_dt_ss: data.header.action_dt_ss, // 提交时间
                effseq: data.header.effseq, // 生效序号
                path: $route.query.pageId
              }
            }"
          >{{ fileItem.filename }}</router-link>
          <a class="item_content_val link_a" slot="right">
            <van-icon name="arrow" />
          </a>
        </ax-down>
      </van-cell>
    </ax-panel>
  </div>
</template>

<script>
export default {
  props: ["data"]
};
</script>

<style></style>
